import React, { useState } from 'react';
import { auth } from '../firebaseConfig';
import { updatePassword, reauthenticateWithCredential, EmailAuthProvider } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

export default function ChangePassword() {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (newPassword !== confirmPassword) {
            setError('Yeni şifreler eşleşmiyor.');
            return;
        }

        const user = auth.currentUser;
        if (!user) {
            navigate('/login');
            return;
        }

        try {
            const credential = EmailAuthProvider.credential(user.email, currentPassword);
            await reauthenticateWithCredential(user, credential);
            await updatePassword(user, newPassword);
            setSuccess('Şifreniz başarıyla değiştirildi.');
            setTimeout(() => navigate('/profile'), 2000);
        } catch (err) {
            setError('Hata: ' + err.message);
        }
    };

    return (
        <div style={containerStyle}>
            <h2>Şifre Değiştir</h2>
            {error && <p style={errorStyle}>{error}</p>}
            {success && <p style={successStyle}>{success}</p>}
            <form onSubmit={handleSubmit} style={formStyle}>
                <div style={inputGroup}>
                    <label>Mevcut Şifre</label>
                    <input type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} required style={inputStyle} />
                </div>
                <div style={inputGroup}>
                    <label>Yeni Şifre</label>
                    <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required style={inputStyle} />
                </div>
                <div style={inputGroup}>
                    <label>Yeni Şifre (Tekrar)</label>
                    <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required style={inputStyle} />
                </div>
                <button type="submit" style={buttonStyle}>Şifreyi Güncelle</button>
                <button type="button" onClick={() => navigate('/profile')} style={cancelButtonStyle}>İptal</button>
            </form>
        </div>
    );
}

// --- Mobil ve iOS Uyumlu Stiller ---
const containerStyle = { 
    maxWidth: '400px', 
    margin: '40px auto', 
    padding: '20px', 
    background: '#fff', 
    borderRadius: '16px', 
    boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
    boxSizing: 'border-box',
    width: '90%',
    paddingTop: 'max(20px, env(safe-area-inset-top))' // iOS Çentik Koruması
};

const formStyle = { display: 'flex', flexDirection: 'column', gap: '15px', boxSizing: 'border-box' };
const inputGroup = { display: 'flex', flexDirection: 'column', gap: '5px' };

const inputStyle = {
    padding: '12px',
    border: '1px solid #dfe6e9',
    borderRadius: '8px',
    fontSize: '16px', // iOS Safari zoom engellemek için kritik
    outline: 'none',
    boxSizing: 'border-box',
    width: '100%',
    WebkitAppearance: 'none'
};

const buttonStyle = { padding: '14px', background: '#27ae60', color: '#fff', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: 'bold', fontSize: '15px', WebkitTapHighlightColor: 'transparent' };
const cancelButtonStyle = { padding: '14px', background: '#95a5a6', color: '#fff', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: 'bold', fontSize: '15px', marginTop: '5px', WebkitTapHighlightColor: 'transparent' };
const errorStyle = { color: 'red', textAlign: 'center', fontSize: '14px' };
const successStyle = { color: 'green', textAlign: 'center', fontSize: '14px' };